import { createContext } from "react";

export interface SidebarContextType {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  mobileOpen: boolean;
  setMobileOpen: (open: boolean) => void;
}

// Objeto de contexto isolado num .ts sem JSX — ver layout-style-context.ts e
// docs/migracao/diario.md (0.4.4) para o motivo (Fast Refresh quebra de verdade
// quando Provider + hook + createContext ficam no mesmo arquivo).
export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);
